export default __webpack_public_path__ + "static/media/bnr-index.b7f84bc3.jpg";